import * as DialogPrimitive from '@radix-ui/react-dialog';
import {
    Dialog,
    DialogPortal,
    DialogOverlay,
    DialogHeader,
    DialogTitle,
    DialogFooter,
} from '~/shadcn/components/ui/Dialog';
import { Button } from '~/shadcn/components/ui/Button';
import { cn } from '~/shadcn/lib/utils';
import { XIcon } from 'lucide-react';

/**
 * A customized Dialog component for prep actions.
 * This modal is deconstructed into its primitive parts to manually control the z-index.
 * The z-index of the overlay is set lower than the content to resolve a stacking issue
 * where the Material-UI Autocomplete component (used in child actions) was rendering
 * between the modal content and its overlay.
 */
function PrepActionModal({ isOpen, onOpenChange, title, children }) {
    return (
        <Dialog open={isOpen} onOpenChange={onOpenChange}>
            <DialogPortal>
                <DialogOverlay className="z-[1280]" />
                <DialogPrimitive.Content
                    className={cn(
                        'bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-[1290] grid w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg border px-12 py-8 shadow-lg duration-200 sm:max-w-xl'
                    )}
                >
                    <DialogHeader>
                        <DialogTitle>{title}</DialogTitle>
                    </DialogHeader>
                    <div className="py-4">{children}</div>
                    <DialogPrimitive.Close className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground cursor-pointer">
                        <XIcon className="h-6 w-6" strokeWidth={2} />
                        <span className="sr-only">Close</span>
                    </DialogPrimitive.Close>
                </DialogPrimitive.Content>
            </DialogPortal>
        </Dialog>
    );
}

export default PrepActionModal;
